import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class CardPlaceholder extends PureComponent {
  render() {
    const heightStyle = {
      height: `${this.props.height}px`
    }
    return (
      <div className='card-placeholder' style={heightStyle} />
    )
  }
}

CardPlaceholder.defaultProps = {
  height: 28
}

CardPlaceholder.propTypes = {
  height: PropTypes.number
}

export default CardPlaceholder



// WEBPACK FOOTER //
// ./src/routes/Board/components/CardPlaceholder.js